import { isSameRawDay } from "owa-datetime";
import type { OwaDate } from "owa-datetime";
import loc, { format } from "owa-localize";
import formatShortTime from "./formatShortTime";
import formatShortWeekDayMonthDay from "./formatShortWeekDayMonthDay";
import { timeRange, timeRangeDifferentDay, timeRangeDifferentDayTimeZoneTransition, timeRangeTimeZoneTransition, } from "./formatTimeRange.locstring.json";

export default function formatTimeRange(start: OwaDate, end: OwaDate, startTimeZoneName: string = "", endTimeZoneName: string = startTimeZoneName): string {
    const crossesTimeZoneTransition = startTimeZoneName !== endTimeZoneName;
    if (!isSameRawDay(start, end)) {
        return crossesTimeZoneTransition
            ? format(loc(timeRangeDifferentDayTimeZoneTransition), formatShortTime(start), startTimeZoneName, formatShortWeekDayMonthDay(end), formatShortTime(end), endTimeZoneName)
            : format(loc(timeRangeDifferentDay), formatShortTime(start), formatShortWeekDayMonthDay(end), formatShortTime(end), startTimeZoneName).trim();
    }
    return crossesTimeZoneTransition
        ? format(loc(timeRangeTimeZoneTransition), formatShortTime(start), startTimeZoneName, formatShortTime(end), endTimeZoneName)
        : format(loc(timeRange), formatShortTime(start), formatShortTime(end), startTimeZoneName).trim();
}
